import { storeToRefs } from 'pinia'
import { useCourseStore } from '@/stores/course'
import type { GetCoursesParams } from '@/domain/repositories/course.repository'

export function useCourse() {
  const courseStore = useCourseStore()
  const { courses, pagination, loading, error, hasCourses, hasError, availableLocales } =
    storeToRefs(courseStore)

  return {
    courses,
    pagination,
    loading,
    error,
    hasCourses,
    showLoadMore: computed(() => hasCourses.value && !!pagination.value?.hasNextPage),
    hasError,
    availableLocales,
    fetchCourses: (params?: GetCoursesParams, signal?: AbortSignal, append?: boolean) =>
      courseStore.fetchCourses(params, signal, append),
    loadMore: courseStore.loadMore,
    fetchAllAvailableLocales: courseStore.fetchAllAvailableLocales,
    reset: courseStore.reset,
    resetCategoryList: courseStore.resetCategoryList,
    clearError: courseStore.clearError,
  }
}
